import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Modal } from '@tailwindComponents/Modal';
import { Button } from '@tailwindComponents/Button';
import { ProductGroupListing, productGroupName } from './productGroups';

export interface ProductArchiveModalProps {
  group: ProductGroupListing | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (group: ProductGroupListing) => void;
}

export function ProductArchiveModal({
  group,
  isOpen,
  onClose,
  onConfirm,
}: ProductArchiveModalProps) {
  const activeSkuCount = group
    ? group.skus.filter((sku) => !sku.isArchived).length
    : 0;

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={onClose}
      title={`Archive ${group ? productGroupName(group) : ''}?`}
    >
      {group && (
        <div className='flex flex-col gap-6 p-4 text-gray-600'>
          <p>
            This will archive every active SKU of {productGroupName(group)} —{' '}
            {activeSkuCount} {activeSkuCount === 1 ? 'SKU' : 'SKUs'}.
          </p>
          <p className='max-w-2xl'>
            The product is removed from your active records but can be
            reinstated at any time by unarchiving any of its SKUs.
          </p>
          <p className='m-2 bg-sky-100 p-6 text-sky-800'>
            <InformationCircleIcon className='mr-2 inline h-5 w-5' />
            This action won&apos;t delete any data or external references.
          </p>
          <div className='flex flex-row justify-center gap-2'>
            <Button
              intent='secondary'
              label='Cancel'
              size='xl'
              onClick={onClose}
            />
            <Button
              intent='danger'
              label='Archive product'
              size='xl'
              onClick={() => {
                onConfirm(group);
                onClose();
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
}
